export class AuthorizedAccountModel {
    admin;
    accountId;
}
//# sourceMappingURL=authorized-account.js.map